window.theme = window.theme || {};

  var cartItems ='';
  
(function($){
  var $ = jQuery = $;
  
   
  theme.config = {
    BASE_URL:'https://optionsmedical.thegenielab.com/api/',
    EXPIRY: 30
  };


  theme.genie = {
    getLocationProduct: function(locationID) {
      return $.getJSON(theme.config.BASE_URL+'getLocationProduct/'+locationID);
    },
    getCart: function() {
      return $.getJSON('/cart.js');
    },
    _sendAjax: function(params) {
      return $.ajax(params)
          .then(function(data) {
            return data;
          }.bind(this))
    },
    getCall: function(url) {
      return this._sendAjax({
        type: 'GET',
        url: url,
        dataType:"json",
      });
    },
    getData: function(url) {
      return this._sendAjax({
        type: 'GET',
        url: url,
        dataType: 'json',
        crossDomain: true
      });
    },
    addItemsToCart: function(data) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      });
    },
    _updateCart: function(params) {
      return $.ajax(params)
          .then(function(cart) {
            return cart;
          }.bind(this))
    },
    showError: function(el,message){
      el.append('<div class="errors text-center">'+message+'</div>');
      setTimeout(function(){
        el.find('.errors').remove();
      }, 3000);
    },
    getUrlParams:function(){
      var vars = [], hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for(var i = 0; i < hashes.length; i++)
      {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    },
    setCookie: function(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie: function(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

  }
  

  var getParamsValues = theme.genie.getUrlParams();     
      //console.log(getParamsValues);
      for (let i in getParamsValues) {     
        if(i=='clinic'){
         vendorId = getParamsValues[i];
          $('body').attr("data-locationid",vendorId);
          $('.locationid').val(vendorId);
          $('#clinic_id').val(vendorId);
          
         
        }
      }
  
  var cookieLocation = theme.genie.getCookie('location_id');
  if(cookieLocation){

    var cookieLocationName = theme.genie.getCookie('location_name');
    const cookieLocationArr = cookieLocationName.split(",");
    $('#location_element').find('.cart--heading').text(cookieLocationArr[0]);
    $('#location_element').find('.totle-inner-price').text(cookieLocationArr[1]);
    $('#location_element_mobile').html(cookieLocationArr[0] +' '+ cookieLocationArr[1] );
    
    let url = new URL(window.location.href);

    //console.log(url);
    var clinicParam =  url.search.includes(cookieLocation);

    if(clinicParam){

    }else{
      let params = new URLSearchParams(url.search);
      params.append('clinic', cookieLocation);
      params.append('filter.p.m.inventory.'+cookieLocation,'InStock' );

      if($('.notification.errors').length > 0){
        
      }else{
        window.location.search = params;
      }
      

    }
    
    $('a').each(function() {
        var href = $(this).attr('href');

      if (typeof href !== 'undefined'){
        if (href != '#') {
          var clinicParam =  href.includes('clinic=');
         if(clinicParam){
          }else{
            var queryParam =  href.includes('?');
            if(queryParam){
            	$(this).attr('href', href + '&clinic='+cookieLocation+'&filter.p.m.inventory.'+cookieLocation+'=InStock');
            }else{
            	$(this).attr('href', href + '?clinic='+cookieLocation+'&filter.p.m.inventory.'+cookieLocation+'=InStock');
            }
          }
        }
      }
        
    });
    
    
  }else{
    
    if($('body').data('locationid') != ''){
    	
      var url = theme.config.BASE_URL + 'getlocationbyid/' + $('body').data('locationid');
        theme.genie.getData(url).then(function(data) {
          if (data.status) {
            $('#autolocation').val(data.data.data);
            $('#location_id').val(data.data.key);
            theme.genie.setCookie('location_id', data.data.key, theme.config.EXPIRY);
            theme.genie.setCookie('location_name', data.data.data, theme.config.EXPIRY);
          } 
        }.bind(this))
        .fail(function(XMLHttpRequest) {
          
        }.bind(this))
        .always(function() {


        }.bind(this));
      
      
    }else{
    	if($('#clinic_selection_thanks_popup').length > 0 && $('#clinic_selection_popup').length > 0){
    
          var popupContent = $('#clinic_selection_popup .modal-content').html();

          $('#clinic_selection_popup .modal-content').remove();

          //var locationId = theme.genie.getCookie('location_id');

          $.colorbox({overlayClose : false,html:popupContent, closeButton: false,
              onComplete: function onComplete() {
                 $('#autolocation').autocomplete({
                    minChars : 1,
                   noCache: true,
                    serviceUrl: theme.config.BASE_URL+'getalllocation',
                         ajaxSettings : {crossDomain: true},
                    onSelect: function (suggestion) {
                        $('#autolocation').val(suggestion.data);
                        $('#location_id').val(suggestion.key);
                        theme.genie.setCookie('location_id', suggestion.key, theme.config.EXPIRY);
                        theme.genie.setCookie('location_name', suggestion.data, theme.config.EXPIRY);

                        $.colorbox.close();

                      let url = new URL(window.location.href);

                      var clinicParam =  url.search.includes(suggestion.key);

                      if(clinicParam){

                      }else{
                        let params = new URLSearchParams(url.search);
                        params.append('clinic', suggestion.key);
                        params.append('filter.p.m.inventory.'+suggestion.key,'InStock' );

                        window.location.search = params;

                      }




                    },
                    onSearchComplete:function (query, suggestions) {
                      if(suggestions.length == 0){
                        $('#autolocation').notify('No location found',{ position:"top center", className: "error" } );
                      }
                    }
                 });
              }});
    
        }
    
    }
  	  
 
  }
  
  
  
  $('body').on('click', '#checkout_id_delivery-pickup', function() {
     $('*[data-pickup-tab-content]').hide();
    
    	$('*[data-pickup-tab-content] .content-box__row').each(function () {
          var cookieLocation = theme.genie.getCookie('location_name');
          if(cookieLocation.length > 0){
            var findLocation = $(this).find('.radio__label__primary .small-text').html();
          var checkForNoLocation = $(this).find('.blank-slate').length;
          if(checkForNoLocation){
          
          }else{
          	if(cookieLocation.replaceAll(/\s/g,'') == findLocation.replaceAll(/\s/g,'')){
              $(this).find('.input-radio').trigger('click');
            }else{
              $(this).hide();
            }
          }
          }
          
          
          
          $('*[data-pickup-tab-content]').show();
        });
    
    });

   $('body').on('click', '#location_element', function() {
     var popupContent = $('#clinic_selection_popup .modal-content').html();

          $('#clinic_selection_popup .modal-content').remove();

          

          $.colorbox({overlayClose : false,html:popupContent, closeButton: false,
              onComplete: function onComplete() {
                 $('#autolocation').autocomplete({
                    minChars : 1,
                    serviceUrl: theme.config.BASE_URL+'getalllocation',
                         ajaxSettings : {crossDomain: true},
                    onSelect: function (suggestion) {
                      var oldLocationId = theme.genie.getCookie('location_id');
                        $('#autolocation').val(suggestion.data);
                        $('#location_id').val(suggestion.key);
                        theme.genie.setCookie('location_id', suggestion.key, theme.config.EXPIRY);
                        theme.genie.setCookie('location_name', suggestion.data, theme.config.EXPIRY);

                        $.colorbox.close();

                      let url = new URL(window.location.href);

                      var clinicParam =  url.search.includes(suggestion.key);

                      if(clinicParam){

                      }else{
                        var clinicParam =  url.search.includes('clinic=');
                        if(clinicParam){
                          let params = new URLSearchParams(url.search);
                          params.delete('filter.p.m.inventory.'+oldLocationId);
                          params.delete('clinic');
                          window.location.search = params;
                        }else{
                          let params = new URLSearchParams(url.search);
                          params.append('clinic', suggestion.key);
                          params.append('filter.p.m.inventory.'+suggestion.key,'InStock' );
                
                          window.location.search = params;
                          }

                      }




                    },
                    onSearchComplete:function (query, suggestions) {
                      if(suggestions.length == 0){
                        $('#autolocation').notify('No location found',{ position:"top center", className: "error" } );
                      }
                    }
                 });
              }});
    
    });

  $('body').on('click', '#location_element_mobile', function() {
     var popupContent = $('#clinic_selection_popup .modal-content').html();

          $('#clinic_selection_popup .modal-content').remove();

          

          $.colorbox({overlayClose : false,html:popupContent, closeButton: false,
              onComplete: function onComplete() {
                 $('#autolocation').autocomplete({
                    minChars : 1,
                    serviceUrl: theme.config.BASE_URL+'getalllocation',
                         ajaxSettings : {crossDomain: true},
                    onSelect: function (suggestion) {
                      var oldLocationId = theme.genie.getCookie('location_id');
                        $('#autolocation').val(suggestion.data);
                        $('#location_id').val(suggestion.key);
                        theme.genie.setCookie('location_id', suggestion.key, theme.config.EXPIRY);
                        theme.genie.setCookie('location_name', suggestion.data, theme.config.EXPIRY);

                        $.colorbox.close();

                      let url = new URL(window.location.href);

                      var clinicParam =  url.search.includes(suggestion.key);

                      if(clinicParam){

                      }else{
                        var clinicParam =  url.search.includes('clinic=');
                        if(clinicParam){
                          let params = new URLSearchParams(url.search);
                          params.delete('filter.p.m.inventory.'+oldLocationId);
                          params.delete('clinic');
                          window.location.search = params;
                        }else{
                          let params = new URLSearchParams(url.search);
                          params.append('clinic', suggestion.key);
                          params.append('filter.p.m.inventory.'+suggestion.key,'InStock' );
                
                          window.location.search = params;
                          }

                      }




                    },
                    onSearchComplete:function (query, suggestions) {
                      if(suggestions.length == 0){
                        $('#autolocation').notify('No location found',{ position:"top center", className: "error" } );
                      }
                    }
                 });
              }});
    
    });
  
  $('body').on('change', '.qty-adjuster__value', function(e) {
    e.preventDefault();
      var variantId = $('select[name="id"]').val();
      var locationId = $('.locationid').val();
    var qty = parseInt($(this).val());
    var element = $(this);
    
    /*var cartVariantId = element.data('variantid');
      var cartLocationId = element.data('locationid');
    
    if (typeof variantId !== 'undefined' && typeof locationId !== 'undefined'){
    
    }else{
    	var variantId = cartVariantId;
      var locationId = cartLocationId;
    }*/
   
      
    if (typeof variantId !== 'undefined' && typeof locationId !== 'undefined'){
		 var url = theme.config.BASE_URL + 'getLocationProduct/' + locationId+'/'+variantId;
        theme.genie.getData(url).then(function(data) {
          if(data.status){
          	var available = parseInt(data.available);
            if(qty > available){
                 $(element).val(available);
            	 element.notify('The available QTY is '+available+'.',{ position:"top center", className: "error" } );
            	//$('.product-add').prop('disabled', true);;
            }else{
            	//$('.product-add').prop('disabled', false);
            }
            
          }
        }.bind(this))
        .fail(function(XMLHttpRequest) {
          
        }.bind(this))
        .always(function() {


        }.bind(this));

    }

    });

  if ($('.template-product').length > 0) {
    var productType = $('.payment-and-quantity').data('type');
    if(productType != 'Gift Cards'){
      
         var variantId = $('select[name="id"]').val();
    var locationId = $('.locationid').val();
        var url = theme.config.BASE_URL + 'getLocationProduct/' + locationId+'/'+variantId;
        theme.genie.getData(url).then(function(data) {
          if(data.status){
          	var available = parseInt(data.available);
            console.log(available);
            if(available == 0 || available < 0 ){
              $('.payment-and-quantity').hide();
              $('.payment-and-quantity__add').hide();
              $('.store-availability-container-outer').hide();
              $('.cart--btn--box').hide();
              $('.recharge-subscription-widget').hide();
              $('.cart--btn--box').after('<p>We have run out of stock for this item.</p>');
            }else{
               
            }
            
          }else{
            $('.payment-and-quantity').hide();
              $('.payment-and-quantity__add').hide();
              $('.store-availability-container-outer').hide();
              $('.cart--btn--box').hide();
              $('.recharge-subscription-widget').hide();
          }
        }.bind(this))
        .fail(function(XMLHttpRequest) {
          
        }.bind(this))
        .always(function() {


        }.bind(this));
    }
   }

  if ($('.no_delivery').length > 0) {


    setTimeout(function(){
           $('*[data-pickup-tab-content] .content-box__row').each(function () {
          var cookieLocation = theme.genie.getCookie('location_name');
          if(cookieLocation.length > 0){
            var findLocation = $(this).find('.radio__label__primary .small-text').html();
          var checkForNoLocation = $(this).find('.blank-slate').length;
          if(checkForNoLocation){
          
          }else{
          	if(cookieLocation.replaceAll(/\s/g,'') == findLocation.replaceAll(/\s/g,'')){
              $(this).find('.input-radio').trigger('click');
            }else{
              $(this).hide();
            }
          }
          }
          
          
          
          $('*[data-pickup-tab-content]').show();
        });
      }, 700);
    

    
    
    $('.content-box__row').each(function () {
       var option = $(this).find('.input-radio').val();
        if(option == 'delivery-shipping'){
          $(this).hide();
        }else{
          $(this).find('.input-radio').trigger('click');
        }
        
        
      });
  }

})(jQuery);